import * as playerSelectors from './AudioPlayer/playerSelectors'
import { createSelector } from 'reselect'
import constant from '../../constant/appConst'

export const getSeek = createSelector(
	playerSelectors.getPlayingInfo,
	playingInfo => playingInfo.seek || 0
)

export const getDuration = createSelector(
	playerSelectors.getPlayingInfo,
	playingInfo => playingInfo.currentGetFileUrl && playingInfo.currentGetFileUrl.duration || constant.defaultSampleDuration
)

export const isBuffering = createSelector(
	playerSelectors.getPlayingInfo,
	playingInfo => playingInfo.buffering
)

export const isPlaying = createSelector(
	playerSelectors.getPlayingInfo,
	playingInfo => playingInfo.playing
)

export const isLoaded = createSelector(
	playerSelectors.getPlayingInfo,
	playingInfo => playingInfo.loaded
)

export const getCurrentTrack = createSelector(
	playerSelectors.getPlayqueueTrack,
	playqueueTrack => playqueueTrack('current') || {}
)

export const getIdCurrentTrack = createSelector(
	getCurrentTrack,
	currentTrack => currentTrack.id
)

export const isCurrentTrack = createSelector(
	getCurrentTrack,
	currentTrack => (type, idElement) => type === currentTrack.originType && idElement === currentTrack.originId
)



// WEBPACK FOOTER //
// ./src/components/miniPlayer/miniPlayerSelectors.js